"use strict";

//
// Tempus Dominus Datepicker Global Settings(learn more: https://getdatepicker.com/6/options/)
//

tempusDominus.DefaultOptions.display.buttons = {
	today: true,
	clear: true,
	close: true
}

tempusDominus.DefaultOptions.display.icons = {
	time: "ki-outline ki-time fs-3",
	date: "ki-outline ki-calendar fs-3",
	up: "ki-outline ki-up fs-3",
	down: "ki-outline ki-down fs-3",
	previous: "ki-outline ki-left fs-3",
	next: "ki-outline ki-right fs-3",
	today: "ki-outline ki-calendar-tick fs-3",
	clear: "ki-outline ki-trash fs-3",
	close: "ki-outline ki-cross fs-2",
};

tempusDominus.DefaultOptions.display.components = {
	calendar: true,
	date: true,
	month: true,
	year: true,
	decades: true,
	clock: true,
	hours: true,
	minutes: true,
	seconds: true,
	//useTwentyfourHour: true,
};

// tempusDominus.DefaultOptions.localization = {
// 	locale: 'en-GB',
// 	startOfTheWeek: 1,
// 	format: 'dd MMMM yyyy HH:mm:ss',
// };